import pako from 'pako';
import { sendWebsocketMessage } from '../../../../../../App';
/**
 * pass in a trade plan object to send to the b.e.
 * If the message is too large, it will zip the message up and send it to the b.e
 * @param {*} param0
 */

// NOTE Create Trade Plan button on Trade Plan form calls this function
// NOTE This uses sendWebsocketMessage to send the Trade Plan to the backend
export function addTradePlan({tradePlanObject, options}) {
  console.log('Trade Plan being sent to BE:', tradePlanObject);
  tradePlanObject.id = new Date().getTime();

  // TODO make sure this didn't break other uses of this function
  if( options ) {
    console.log(`options provided: ${JSON.stringify(options)}`)
    // TODO add them into the tradePlanObject
    tradePlanObject.optionManagement = options
  }

  const messageObject = {
    messageType: 'addTradePlan',
    addTradePlan: tradePlanObject,
  };

  const message = JSON.stringify(messageObject);
  if (new Blob([message]).size > 7500) {
    //think max size is 8192
    console.log(message.length);
    console.log('message too large: ' + new Blob([message]).size + '. zipping');
    const compressed = pako.gzip(message);
    //  console.log(compressed);
    console.log(compressed.length);
    sendWebsocketMessage(compressed);

    //alert("websocket message is too long.")
  } else {
    sendWebsocketMessage(messageObject);
  }
}
